import { API_APPY_CSV_SPECIAL, API_GET_JWT_INFORM, API_GET_PRODUCTS_IN_STORE, API_GET_SETTING_APP, API_SAVE_JWT_INFORM, API_STATUS_CSV_SPECIAL } from 'configs/api'
import { paramsGetSetting, reqPostAppSettingType } from 'models/appSetting'
import { OS_TYPE } from 'models/magazine'
import networkAdapter from 'utilities/networkAdapter'

export const getAppSettingApi = async (params: paramsGetSetting) => {
  try {
    const dataMagazine = await networkAdapter.get(API_GET_SETTING_APP, params)
    return dataMagazine.data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine app', error)
  }
}

export const updateAppSettingApi = async (req: reqPostAppSettingType) => {
  try {
    const dataMagazine = await networkAdapter.put(API_GET_SETTING_APP, req)
    return dataMagazine.data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine app', error)
  }
}

export const saveApppSettingApi = async (req: any) => {
  try {
    const dataMagazine = await networkAdapter.post(API_GET_SETTING_APP, req)
    return dataMagazine
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine app', error)
  }
}

export const getJwtInformApi = async (params: paramsGetSetting) => {
  try {
    const dataMagazine = await networkAdapter.get(API_GET_JWT_INFORM, params)
    return dataMagazine.data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine app', error)
  }
}

export const saveJwtInform = async (req: any) => {
  try {
    const data = await networkAdapter.post(API_SAVE_JWT_INFORM, req)
    return data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine app', error)
  }
}

export const apiGetProductsAtStore = async (params: { app_id: number, os_type: OS_TYPE }) => {
  try {
    const dataGet = await networkAdapter.post(API_GET_PRODUCTS_IN_STORE, params)
    return dataGet
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine app', error)
  }
}


export const apiApplySpecialCSV = async () => {
  try {
    const dataGet = await networkAdapter.post(API_APPY_CSV_SPECIAL, {})
    return dataGet
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error apiApplySpecialCSV', error)
  }
}

export const apiGetStatusSpecialCSV = async () => {
  try {
    const dataGet = await networkAdapter.get(API_STATUS_CSV_SPECIAL)
    return dataGet
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error apiGetStatusSpecialCSV', error)
  }
}

